import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import { CircularProgress, Grid, makeStyles, Typography } from "@material-ui/core";
import Botao from "../../../shared/components/Botao";
import Paginacao from '../../../shared/components/Paginacao';
import Loading from "../../../shared/components/Loading";
import ScrollBarGradiente from "../../../shared/components/ScrollBarGradiente";
import { formatarValorCasasDecimais } from '../../../shared/utils/Formatacao';
import { codigoLoteEmRascunho, codigoTipoLoteNormal, CODIGO_TECLA_P, CODIGO_TECLA_U, NOME_ARQUIVO_LISTAGEM_DE_LOTES } from "../../../shared/utils/Constantes"
import ListaLotes from './ListaLotes';
import LotesFiltros from "./LotesFiltros";
import LotesManager from '../LotesManager';
import { v4 as uuidv4 } from 'uuid';
import queryString from 'query-string';
import ReactDOM from "react-dom";
import moment from "moment";
import ContainerPagina from "../../../shared/components/ContainerPagina";
import ModalVisualizacaoDadosLote from "./ModalVisualizacaoLote";
import { Book, Download, FileText } from 'react-feather';
import LinkButton from "../../../shared/components/LinkButton";
import { SECONDARY_COLOR } from '../../../theme';
import store from '../../../store';
import { mensagemAlertaActions } from '../../mensagemAlerta/redux';
import manualOnboarding from '../files/manualOnboarding.pdf'
import { NOME_ARQUIVO_RELATORIO_DE_UTILIZACAO } from '../../../shared/utils/Constantes'
import { iniciarDownload } from '../../../shared/utils/ArquivoUtil';

const PAGINA_INICIAL = 1
const ITENS_PAGINA_INICIAL = 15;

const filtrosIniciais = (codigoLote, dataLote) => ({
    busca: codigoLote ? codigoLote : '',
    tipos: [],
    status: [],
    dataInicio: codigoLote ? moment(dataLote) : moment().subtract(15, 'd'),
    dataFinal: codigoLote ? moment(dataLote) : moment(),
});

const Lotes = () => {
    const classes = useStyles();
    const history = useHistory();
    const usuario = useSelector((state) => state.login.usuario.usuario);
    const ehPerfilLaboratorio = !isNaN(usuario);
    const { search } = useLocation();
    const { codigoLote, dataLote } = queryString.parse(search);
    const [listaLotes, setListaLotes] = useState([]);
    const [tiposOpcoes, setTiposOpcoes] = useState([]);
    const [statusOpcoes, setStatusOpcoes] = useState([]);
    const [possuiLotes, setPossuiLotes] = useState(true);
    const [indexPaginaAtual, setIndexPaginaAtual] = useState(0);
    const [carregandoLotes, setCarregandoLotes] = useState(true);
    const [quantidadeTotalItens, setQuantidadeTotalItens] = useState(null);
    const [quantidadeItensPorPagina, setQuantidadeItensPorPagina] = useState(ITENS_PAGINA_INICIAL);
    const contadorCarregandoLotes = useRef(0);
    const ultimoUUIDRequisicao = useRef("");
    const filtrosRef = useRef(filtrosIniciais(codigoLote, dataLote));
    const [filtros, setFiltros] = useState(filtrosIniciais(codigoLote, dataLote));
    const [modalLoteAberta, setModalLoteAberta] = useState(false);
    const [visualizarLote, setVisualizarLote] = useState([])
    const [carregandoAmostras, setCarregandoAmostras] = useState(false);
    const [listaAmostras, setListaAmostras] = useState([]);
    const [listaEventos, setListaEventos] = useState([]);
    const [carregandoPlanilha, setCarregandoPlanilha] = useState(false);
    const [carregandoManifestoCarga, setCarregandoManifestoCarga] = useState(false);
    const [baixandoRelatorio, setBaixandoRelatorio] = useState(false);
    const [carregandoDadosEnvio, setCarregandoDadosEnvio] = useState(false);

    const [ordenacao, setOrdenacao] = useState({
        coluna: 'DataCadastro',
        decrescente: true
    });

    const [paginacao, setPaginacao] = useState({
        pagina: PAGINA_INICIAL,
        itensPagina: ITENS_PAGINA_INICIAL,
    });

    const [lotesSelecionaveis, setLotesSelecionaveis] = useState([]);
    const [lotesSelecionados, setLotesSelecionados] = useState([]);

    useEffect(() => {
        setLotesSelecionaveis(listaLotes.filter(lote => lote.status.codigo !== codigoLoteEmRascunho));
    }, [listaLotes]);

    const handleSelecionarTodos = (event) => {
        if (event?.target?.checked) {
            setLotesSelecionados(lotesSelecionaveis);
        }
        else {
            setLotesSelecionados([]);
        }
    }

    const handleSelecionar = (lote) => {
        if (lotesSelecionados.indexOf(lote) >= 0) {
            setLotesSelecionados(lotesSelecionados.filter(item => item.id !== lote.id));
        }
        else {
            setLotesSelecionados(lotesSelecionados.concat([lote]));
        }
    }

    const handleClickImprimirManifestoCarga = useCallback(async () => {
        setCarregandoManifestoCarga(true);

        await LotesManager.imprimirManifestoCarga(lotesSelecionados);

        setLotesSelecionados([]);
        setCarregandoManifestoCarga(false);
    }, [lotesSelecionados]);

    useEffect(() => {
        const tratarShortcutKeydown = (event) => {
            if (!event.ctrlKey) return;

            switch (event.which) {
                case CODIGO_TECLA_P:
                    event.preventDefault();
                    handleClickImprimirManifestoCarga();
                    break;
                case CODIGO_TECLA_U:
                    event.preventDefault();
                    handleClickNoveLote();
                    break;
                default: break;
            }
        }

        document.addEventListener('keydown', tratarShortcutKeydown);

        return () => document.removeEventListener('keydown', tratarShortcutKeydown);
    }, [handleClickImprimirManifestoCarga]);

    const retornoDesabilitado = carregandoLotes || indexPaginaAtual === 0;

    const avancoDesabilitado =
        !possuiLotes ||
        carregandoLotes ||
        (listaLotes && listaLotes.length < quantidadeItensPorPagina) ||
        listaLotes.length === quantidadeTotalItens;

    const incrementarContadorCarregandoLotes = useCallback(() => {
        contadorCarregandoLotes.current++;
        setCarregandoLotes(true);
    }, [])

    const decrementarContadorCarregandoLotes = useCallback(() => {
        if (contadorCarregandoLotes.current > 0) {
            contadorCarregandoLotes.current--;
        }
        if (contadorCarregandoLotes.current === 0) {
            setCarregandoLotes(false);
        }
    }, [])

    const listarLotes = useCallback(async (filtrosParam, ordenacaoParam, paginacaoParam) => {
        incrementarContadorCarregandoLotes();

        const operacoesListagem = {
            filtros: filtrosParam,
            ordenacao: ordenacaoParam,
            paginacao: paginacaoParam,
        }
        ultimoUUIDRequisicao.current = uuidv4();
        const resultado = await LotesManager.listarLotes(operacoesListagem, ultimoUUIDRequisicao.current);

        if (resultado && resultado.itens && resultado.itens.length > 0) {
            if (resultado.uuid === ultimoUUIDRequisicao.current) {
                setListaLotes(resultado.itens);
                setPossuiLotes(true);
            }
        }
        else {
            setListaLotes([]);
            setPossuiLotes(false);
        }

        setQuantidadeTotalItens(resultado.totalItens);
        decrementarContadorCarregandoLotes();
    }, [incrementarContadorCarregandoLotes, decrementarContadorCarregandoLotes])

    const obterAssinaturaDigitalLote = async (lote) => {
        await LotesManager.obterImagemAssinaturaLote(lote.id);
    }

    const obterImagemBiopsiaLote = async (lote) => {
        await LotesManager.obterImagemBiopsiaLote(lote.id);
    }

    const obterReciboRecolhimento = async (lote) => {
        await LotesManager.gerarReciboRecolhimento(lote.id);
    }

    const handleClickManual = () => {
        fetch(manualOnboarding).then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                const alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = "Manual de Utilização - Onboarding.pdf";
                alink.click();
            });
        });
    };

    const handleClickNoveLote = () => {
        history.push({
            pathname: "/dados-lote",
        })
    }

    const handleClickBaixarPlanilha = async () => {
        setCarregandoPlanilha(true);

        const operacoesListagem = {
            filtros: filtros,
            ordenacao: ordenacao,
        }

        await LotesManager.baixarPlanilha(operacoesListagem)
            .then((resposta) => {
                const nomeArquivo = NOME_ARQUIVO_LISTAGEM_DE_LOTES + moment().format('DDMMYYYYHHmmss');
                iniciarDownload(resposta, nomeArquivo);
            })
            .finally(() => setCarregandoPlanilha(false));
    }

    const obterPaginaInicial = () => {
        if (listaLotes && listaLotes.length === 0) return 0;

        const paginaAtual = indexPaginaAtual === 0 ? 1 : indexPaginaAtual;

        return formatarValorCasasDecimais((paginaAtual - PAGINA_INICIAL) * quantidadeItensPorPagina + 1);
    }

    const obterPaginaFinal = () => {
        if (listaLotes && listaLotes.length === 0) return 0;

        const paginaAtual = indexPaginaAtual === 0 ? 1 : indexPaginaAtual;
        return formatarValorCasasDecimais((paginaAtual - PAGINA_INICIAL) * quantidadeItensPorPagina + listaLotes.length);
    }

    const handleChangeItensPorPagina = (event) => {
        setQuantidadeItensPorPagina(event.target.value);
        setPaginacao({
            ...paginacao,
            pagina: PAGINA_INICIAL,
            itensPagina: event.target.value,
        });

        setListaLotes([]);
        setIndexPaginaAtual(0);
    }

    const handleChangePagina = (avanco) => {
        const paginaAtual = indexPaginaAtual === 0 ? 1 : indexPaginaAtual;
        const paginaAVisualizar = avanco ? paginaAtual + 1 : paginaAtual - 1;

        setIndexPaginaAtual(paginaAVisualizar === 1 ? 0 : paginaAVisualizar)
        setPaginacao({
            ...paginacao,
            pagina: paginaAVisualizar,
            itensPagina: quantidadeItensPorPagina,
        })

        setListaLotes([]);
    }

    const voltarPaginaInicial = () => {
        setPaginacao({
            ...paginacao,
            pagina: PAGINA_INICIAL,
        })
        setIndexPaginaAtual(0);
    };

    const handleOrdenacao = () => {
        voltarPaginaInicial();
        setOrdenacao({
            ...ordenacao,
            decrescente: !ordenacao.decrescente,
        });
    }

    const handleChangeFiltros = (novosFiltros) => {
        const filtrosMudaram =
            novosFiltros.busca !== filtrosRef.current.busca ||
            (!novosFiltros.dataInicio?.isSame(filtrosRef.current.dataInicio, "date")) ||
            (!novosFiltros.dataFinal?.isSame(filtrosRef.current.dataFinal, "date")) ||
            (filtrosRef.current.tipos && novosFiltros.tipos.length !== filtrosRef.current.tipos.length) ||
            (filtrosRef.current.status && novosFiltros.status.length !== filtrosRef.current.status.length);

        if (filtrosMudaram) {
            filtrosRef.current = novosFiltros;

            ReactDOM.unstable_batchedUpdates(() => {
                setFiltros(novosFiltros);

                if (paginacao.pagina !== PAGINA_INICIAL)
                    voltarPaginaInicial();
            });
        }
    };

    const abrirModalVisualizacao = async (lote) => {
        setModalLoteAberta(true)
        setCarregandoAmostras(true)
        setVisualizarLote(lote)

        const amostras = await LotesManager.listarAmostrasLote(lote.id);
        const eventos = await LotesManager.listarEventosLote(lote.id);

        setListaEventos(eventos || []);
        setListaAmostras(amostras || []);

        setCarregandoAmostras(false)
    }

    const handleFecharModalVisualizacao = () => {
        setModalLoteAberta(false)
    }

    const downloadRelatorioUtilizacao = async () => {
        setBaixandoRelatorio(true)

        const periodo = {
            dataInicio: filtros.dataInicio,
            dataFim: filtros.dataFinal,
        };

        await LotesManager.baixarRelatorioUtilizacao(periodo)
            .then((resposta) => {
                if (resposta) {
                    const nomeArquivo = NOME_ARQUIVO_RELATORIO_DE_UTILIZACAO + moment().format('DDMMYYYYHHmmss');
                    iniciarDownload(resposta, nomeArquivo);
                }
            }).finally(() => setBaixandoRelatorio(false));
    }

    useEffect(() => {
        LotesManager.listarTiposLote().then((tipos) => {
            const tipoLoteNormal = tipos.find(t => t.codigo === codigoTipoLoteNormal);

            tipos.splice(tipos.indexOf(tipoLoteNormal), 1);

            tipos.unshift(tipoLoteNormal);

            setTiposOpcoes(tipos);
        });
        LotesManager.listarStatusLote().then((status) => setStatusOpcoes(status));
    }, [])

    useEffect(() => {
        if (!filtros.dataInicio || !filtros.dataFinal) {
            store.dispatch(mensagemAlertaActions.exibirNotificacao("Para pesquisar, selecione um período máximo de 31 dias."));
            return;
        }

        listarLotes(filtros, ordenacao, paginacao);
    }, [listarLotes, filtros, ordenacao, paginacao]);

    const handleImprimirDadosEnvio = async () => {
        setCarregandoDadosEnvio(true);

        await LotesManager.imprimirDadosEnvio();

        setCarregandoDadosEnvio(false);
    }

    return (
        <ContainerPagina>
            <ModalVisualizacaoDadosLote
                modalAberto={modalLoteAberta}
                handleFecharModal={handleFecharModalVisualizacao}
                carregandoAmostras={carregandoAmostras}
                lote={visualizarLote}
                amostras={listaAmostras}
                eventos={listaEventos}
            />
            <Grid container>
                <Grid container justifyContent={'space-between'}>
                    <Grid item xs={5}>
                        <Typography variant="h2" className="mt-4 mb-8">
                            Cadastro e gerenciamento de lotes
                        </Typography>
                    </Grid>
                    <Grid container item xs={7} className={classes.gridBotoes}>
                        {!ehPerfilLaboratorio && (
                            <Grid item>
                                <Botao
                                    id="relatorioUtilizacao"
                                    type="primary"
                                    className={classes.botaoSuperior}
                                    titulo="Relatório de utilização"
                                    onClick={downloadRelatorioUtilizacao}
                                    disabled={(!filtros.dataInicio || !filtros.dataFinal) || baixandoRelatorio}
                                    carregando={baixandoRelatorio}
                                    icone={<FileText size={20} />}
                                    alignIcone="left"
                                    textoTooltip="Relatório referente ao período selecionado."
                                />
                            </Grid>
                        )}
                        <Grid item>
                            <Botao
                                id="manualOnboarding"
                                type="primary"
                                className={classes.botaoSuperior}
                                titulo="Manual de utilização"
                                uppercase={false}
                                onClick={handleClickManual}
                                carregando={false}
                                icone={<Book size={20} />}
                                alignIcone="left"
                            />
                        </Grid>
                        <Grid item>
                            <Botao
                                id="novoLote"
                                type="primary"
                                className={classes.botaoSuperior}
                                titulo="Novo lote"
                                atalho="(CTRL + U)"
                                uppercase={false}
                                onClick={handleClickNoveLote}
                                carregando={false}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} className="pb-2">
                    <LotesFiltros
                        tiposOpcoes={tiposOpcoes}
                        statusOpcoes={statusOpcoes}
                        filtros={filtros}
                        handleChangeFiltros={handleChangeFiltros}
                    />
                </Grid>

                {carregandoLotes ?
                    (<Grid item xs={12} className={classes.loading}>
                        <Loading loading size={30} className={"mt-0 mb-0"} />
                    </Grid>) :
                    (<Grid item xs={12} className={classes.containerTabela}>
                        <ScrollBarGradiente
                            estilo={{
                                height: "100%",
                                width: "100%",
                            }}
                            larguraGradiente={"0"}
                        >
                            <ListaLotes
                                listaLotes={listaLotes}
                                handleOrdenacao={handleOrdenacao}
                                ordemDecrescente={ordenacao.decrescente}
                                handleVisualizarLote={abrirModalVisualizacao}
                                lotesSelecionados={lotesSelecionados}
                                lotesSelecionaveis={lotesSelecionaveis}
                                handleSelecionar={handleSelecionar}
                                handleSelecionarTodos={handleSelecionarTodos}
                                handleClickBaixarAssinaturaDigital={obterAssinaturaDigitalLote}
                                handleClickBaixarImagemBiopsia={obterImagemBiopsiaLote}
                                handleClickGerarReciboRecolhimento={obterReciboRecolhimento}
                            />

                        </ScrollBarGradiente>
                    </Grid>)
                }
                <Grid item container xs={12} justifyContent='space-between'>
                    <Grid item xs={5} className={classes.paginacao}>
                        <Paginacao
                            quantidadeItensPorPagina={quantidadeItensPorPagina}
                            retornoDesabilitado={retornoDesabilitado}
                            avancoDesabilitado={avancoDesabilitado}
                            quantidadeTotalItens={quantidadeTotalItens === null ? 0 : formatarValorCasasDecimais(quantidadeTotalItens)}
                            inicioPagina={() => obterPaginaInicial()}
                            finalPagina={() => obterPaginaFinal()}
                            handleChangeSelect={(event) => handleChangeItensPorPagina(event)}
                            mudarPagina={handleChangePagina}
                            textoExibicao="Exibindo lotes"
                        />
                    </Grid>
                    <Grid item container xs={7} className={classes.gridBotoes}>
                        <Grid item>
                            <LinkButton
                                label="Exportar lista de lotes"
                                icone={
                                    carregandoPlanilha
                                        ? <CircularProgress size={24} />
                                        : <Download color={SECONDARY_COLOR} />
                                }
                                onClick={handleClickBaixarPlanilha}
                                desabilitado={carregandoPlanilha}
                                fontSize={16}
                                className={classes.botaoBaixarPlanilha}
                            />
                        </Grid>
                        <Grid item>
                            <Botao
                                id="imprimirDadosEnvio"
                                type="secondary"
                                titulo="Imprimir dados de envio"
                                className={classes.botoesImprimir}
                                uppercase={false}
                                onClick={handleImprimirDadosEnvio}
                                carregando={carregandoDadosEnvio}
                            />
                        </Grid>
                        <Grid item>
                            <Botao
                                id="imprimirManifestoCarga"
                                type="secondary"
                                className={classes.botoesImprimir}
                                titulo="Imprimir manifesto"
                                atalho="(CTRL + P)"
                                uppercase={false}
                                onClick={handleClickImprimirManifestoCarga}
                                carregando={carregandoManifestoCarga}
                                disabled={lotesSelecionados.length === 0}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ContainerPagina>
    );
}

const useStyles = makeStyles(theme => ({
    containerTabela: {
        height: "calc(90vh - 225px)",
    },
    loading: {
        height: "calc(100vh - 320px)",
        display: "flex",
        alignItems: "center",
    },
    botaoSuperior: {
        height: "56px",
        padding: '16px 24px',
        width: '220px',
        fontSize: '14px'
    },
    paginacao: {
        paddingTop: "10px",
    },
    botaoBaixarPlanilha: {
        paddingTop: "15px",
        width: "max-content",
    },
    rodape: {
        width: "calc(100% - 320px)"
    },
    botoesImprimir: {
        marginTop: "8px",
        fontSize: "14px",
    },
    gridBotoes: {
        display: 'flex',
        justifyContent: 'end',
        gap: '26px',
        paddingBottom: '15px'
    },
}));

export default Lotes;